import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
// Import Actions
import {
    FETCH_REVIEWS_FOR_PAGE,
    FETCH_REVIEW_SUCCESS,
    SET_PAGE_FILTERS,
    SET_VENUE_FILTER,
    SET_VENUE_FILTER_ITEM,
    RESET_FILTERS,
    SHORTLISTING_VENUE_FOR_EVENT,
    SET_SUBAREAS,
    SET_PAGETAGS,
    SET_FILTERS,
    GET_VENUES,
    FETCHING_VENUES,
    SET_APPLIED_FILTERS,
    FETCH_VENUE,
    FETCH_VENUE_PAGE,
    FETCH_ASSET_PAGE,
    FETCH_REVIEW_PAGE,
    FETCH_PACKAGE_PAGE,
    FETCHING_VENUE,
    FETCH_REVIEW,
    FETCHING_REVIEW,
    FETCHING_VENUE_COMMENTS,
    FETCH_VENUE_COMMENTS,
    TOGGLE_NEW_COMMENT,
    FETCH_USER_COMMENT,
    EDIT_USER_COMMENT,
    FETCHING_REPORTED_COMMENT,
    FETCH_REPORTED_COMMENT,
    UPDATING_REPORTED_COMMENT,
    TOGGLE_NEW_EVENT_PLAN_MODAL,
    EVENT_MADE_STATE,
    SET_SELECTED_VENUE,
    FETCHING_SEOLINKS,
    LOAD_SEOLINK,
    FETCHING_SEARCHLINKS,
    LOAD_SEARCHLINK,
    SHORTLISTING_VENUE_FROM_LIST,
    SET_MIN_MAX_VENUE_FILTER_ITEM,
    SET_REVIEW_MODAL_STATE,
    SET_REVIEW_LIST_MODAL_STATE,
    FETCHING_SIMILAR_VENUES,
    FETCH_SIMILAR_VENUES,
    //FETCHING_POPULAR_VEUNES,
    FETCH_POPULAR_VENUES,
    SET_ACTIVE_LINK_FILTERS,
    UPDATE_LODE_MORE_VENUES,
    UPDATE_VENUE_SEARCH_VALIDATORS,
    UPDATING_VENUE_SEARCH_VALIDATORS,
    UPDATE_VENUE_USER_REVIEW,
    UPDATING_VENUE_USER_REVIEW,
    DELETING_USER_COMMENT,
    UPDATING_USER_COMMENT,
    FETCH_COMPARE_VENUES,
    FETCH_VENUE_DATA_FOR_COMPARE_PAGE,
    FETCHING_COMPARE_VENUES,
    FETCHING_VENUE_DATA_FOR_COMPARE_PAGE,
    CLEAR_COMPARE_VENUE_DATA,
    SET_REVIEW_SUCCESS_MODAL_STATE,
    FETCH_QNA_PAGE,
    ADD_ANSWER_MODAL_STATE,
    LOAD_SUBLINK_PAGE,
    GET_QNA_SUGGESTION_LIST,
    IS_USER_QUESTION_POSTED,
    SET_SUCCESS_MODAL_STATE,
    QUESTION_ALREADY_EXIST,
    FETCH_USER_QUESTION,
    DELETING_USER_QUESTION,
    PROCESSING_DELETE_QUESTION,
    FETCH_MORE_QNA,
    SET_SORT_FILTERS,
    CLICKED_VENUE_SEARCH_PAGE,
    IS_OPEN_GALLERY_FOR_SEARCHPAGE,
    FETCH_VENUE_SEARCH_PAGE_ALL_ASSET,
    UPDATE_QNA_HOMEPAGE,
    SET_VENUE_TOUR_MODAL_VISIBILTIY,
    SET_SAYA_DATE_STATUS,
    SAYA_DATE_HIDE_BY_USER,
    SET_SUCCESS_SCREEN,
    GET_REVIEW_TICKET_DATA
} from '../actions/VenueActions';

// Initial State
const initialState = {
    pagetags: {},
    isBaseFiltersLoaded: false,
    isLocationFiltersLoaded: false,
    venueSearchFilters: [],
    sortFilters: [],
    venueSearchParams: [],
    appliedFilters: {},
    isFetchingVenues: false,
    list: [],
    city: '',
    totalCount: 0,
    pageNum: 1,
    pageSize: 30,
    isLoadingVenuePage: false,
    isLoadingVenueData: false,
    venue: {},
    mainPageVenue: {},
    packagePageVenue: {},
    assetPageVenue: {},
    reviewPageVenue: {},
    packages: [],
    images: [],
    menus: [],
    realevents: [],
    review: {},
    comments: [],
    commentMap: {},
    reviewPageNum: 1,
    totalCommentsCount: 0,
    userHasCommented: false,
    userComment: {},
    isLoadingUserReviewsPage: true,
    isPostingUserComment: false,
    isEditingUserComment: false,
    isUpdatingUserComment: false,
    isDeletingUserComment: false,
    isFetchingUserReviews: false,
    isFetchingComments: false,
    userReviews: [],
    userReviewCount: 0,
    currentUserReviewPage: 1,
    reportedComment: {},
    isFetchingReportedComment: false,
    isReportingComment: false,
    selectedVenue: {},
    recoVenues: [],
    isEventMade: false,
    isFetchingSimilarVenues: false,
    similarVenues: [],
    isFetchingPopularVenues: false,
    popularVenues: [],
    isFetchingCompareVenues: false,
    compareVenues: [],
    similarSubAreas: {},
    isFetchingSearchLink: false,
    isUpdatingVenueSearchValidators: false,
    searchlink: {},
    activeLinkFilters: {
        occasions: '',
        venuetypes: '',
        localities: '',
    },
    venueFormFilters: {},
    searchValidators: {},
    isReviewModalVisible: false,
    isReviewSuccessModalVisible: false,
    isReviewListModalVisible: false,
    isSavingUserProfileComment: false,
    isShortlistingVenue: false,
    venueExpertReview: {},
    venueQas: [],
    venueFaqs: [
        {
            _id: 1,
            question: 'What is the naem ?',
            answer: 'My name is bhavya',
        },
    ],
    venueSpaces: [],
    venueExpert: {},
    compareVenue: {},
    sublinkPageData: {},
    questionAlreadyExistVisiblity: false,
    totalReviewCount: 0,
    clickedVenueAssets: {},
    clickedVenue: {},
    isOpenGalleryForSearchPage: false,
    updateQnaPage: false,
    isVenueTourModalVisible: false,
    isSayaDate: false,
    isHideSayaDateBanner: false,
    isShowSuccessScreen: false,
    reviewticketdata: {}
};

const VenueReducers = (state = initialState, action) => {
    let clickedVenueAssets = {};
    switch (action.type) {
        case UPDATE_LODE_MORE_VENUES:
            let prevVenues = state.list;
            let newVenueList = [];
            if (action.newVenues && action.newVenues.length > 0) {
                newVenueList = prevVenues.concat(action.newVenues);

                return {
                    ...state,
                    list: newVenueList,
                    pageNum: action.pageNum,
                    totalCount: action.totalCount,
                };
            } else {
                newVenueList = prevVenues;
                return {
                    ...state,
                    list: newVenueList,
                    pageNum: state.pageNum,
                    totalCount: state.totalCount,
                };
            }

        case SET_ACTIVE_LINK_FILTERS:
            return {
                ...state,
                activeLinkFilters: action.activeLinkFilters,
            };
            case SET_SUCCESS_SCREEN:
                return {
                    ...state,
                    isShowSuccessScreen: action.isShowSuccessScreen,
                };     
        case SET_SAYA_DATE_STATUS:
            return {
                ...state,
                isSayaDate: action.isSayaDate,
            };
            case GET_REVIEW_TICKET_DATA:
                return {
                    ...state,
                    reviewticketdata: action.reviewticketdata,
                };
        case SAYA_DATE_HIDE_BY_USER:
            return {
                ...state,
                isHideSayaDateBanner: action.isHideSayaDateBanner,
            };
        case SET_REVIEW_MODAL_STATE:
            return {
                ...state,
                isReviewModalVisible: action.isReviewModalVisible,
            };

        case SET_REVIEW_SUCCESS_MODAL_STATE:
            return {
                ...state,
                isReviewSuccessModalVisible: action.isReviewSuccessModalVisible,
            };

        case SET_REVIEW_LIST_MODAL_STATE:
            return {
                ...state,
                isReviewListModalVisible: action.isReviewListModalVisible,
            };

        case SET_PAGETAGS:
            return {
                ...state,
                pagetags: action.pagetags,
            };

        case SET_VENUE_FILTER_ITEM:
            let venueFilters = state.venueSearchFilters.map((filterItem) => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map((item) => {
                        item.isSelected = kebabCase(item.value) === kebabCase(action.value);
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                venueSearchFilters: venueFilters,
            };

        case SET_MIN_MAX_VENUE_FILTER_ITEM:
            let venueMinFilters = state.venueSearchFilters.map((filterItem) => {
                if (filterItem.minParam === action.paramName) {
                    filterItem.minParams = filterItem?.minParams?.map((item) => {
                        item.isSelected = toString(item.value) === toString(action.value);
                        return item;
                    });
                } else if (filterItem.maxParam === action.paramName) {
                    filterItem.maxParams = filterItem?.maxParams?.map((item) => {
                        item.isSelected = toString(item.value) === toString(action.value);
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                venueSearchFilters: venueMinFilters,
            };

        case SET_VENUE_FILTER:
            let filters = state.venueSearchFilters.map((filterItem) => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map((item) => {
                        if (toString(item.value) === toString(action.value)) {
                            item.isSelected = action.isSelected;
                        }
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                venueSearchFilters: filters,
            };

        case FETCHING_VENUES:
            return {
                ...state,
                isFetchingVenues: action.isFetchingVenues,
            };

        case GET_VENUES:
            return {
                ...state,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                searchlink: action.searchlink,
                searchValidators: action.searchValidators,
            };

        case UPDATING_VENUE_SEARCH_VALIDATORS:
            return {
                ...state,
                isUpdatingVenueSearchValidators: action.isUpdatingVenueSearchValidators,
            };

        case UPDATE_VENUE_SEARCH_VALIDATORS:
            return {
                ...state,
                isUpdatingVenueSearchValidators: action.isUpdatingVenueSearchValidators,
                searchValidators: action.searchValidators,
                totalCount: action.totalCount,
            };

        case SHORTLISTING_VENUE_FROM_LIST:
            let newList = state.list.map((item) => {
                if (item._id === action.venueid) {
                    item.isShortlisting = action.value;
                }
                return item;
            });
            return {
                ...state,
                list: newList,
                isShortlistingVenue: action.value,
                shortlistingVenueId: action.venueid,
            };

        case SHORTLISTING_VENUE_FOR_EVENT:
            return {
                ...state,
                isShortlistingVenue: action.isShortlistingVenue,
            };

        case SET_APPLIED_FILTERS:
            return {
                ...state,
                appliedFilters: action.appliedFilters,
            };

        case SET_FILTERS:
            return {
                ...state,
                venueSearchFilters: action.venueSearchFilters,
                sortFilters: action.sortFilters,
                isBaseFiltersLoaded: action.isBaseFiltersLoaded,
                venueSearchParams: action.venueSearchParams,
            };

        case SET_PAGE_FILTERS:
            return {
                ...state,
                venueSearchFilters: action.venueSearchFilters,
            };

        case FETCHING_VENUE:
            return {
                ...state,
                isLoadingVenuePage: action.isLoadingVenuePage,
            };

        case FETCH_VENUE:
            return {
                ...state,
                venue: action.venue,
            };

        case FETCH_VENUE_PAGE:
            return {
                ...state,
                venue: action.venue,
                mainPageVenue: action.mainPageVenue,
                packages: action.packages,
                images: action.images,
                menus: action.menus,
                comments: action.comments,
                totalCommentsCount: action.totalCommentsCount,
                reviewPageNum: action.reviewPageNum,
                isLoadingVenuePage: action.isLoadingVenuePage,
                similarVenues: action.similarVenues,
                venueExpertReview: action.venueExpertReview,
                venueFaqs: action.venueFaqs,
                venueQas: action.venueQas,
                venueSpaces: action.venueSpaces,
                realevents: action.realevents,
                venueExpert: action.venueExpert,
                popularVenues: action.popularVenues,
            };

        case FETCH_ASSET_PAGE:
            return {
                ...state,
                venue: action.venue,
                assetPageVenue: action.assetPageVenue,
                images: action.images,
                realevents: action.realevents,
                isLoadingVenuePage: action.isLoadingVenuePage,
                similarVenues: action.similarVenues,
                popularVenues: action.popularVenues,
            };

        case FETCH_REVIEW_PAGE:
            return {
                ...state,
                venue: action.venue,
                reviewPageVenue: action.reviewPageVenue,
                comments: action.comments,
                totalCommentsCount: action.totalCommentsCount,
                reviewPageNum: action.reviewPageNum,
                isLoadingVenuePage: action.isLoadingVenuePage,
                similarVenues: action.similarVenues,
                popularVenues: action.popularVenues,
            };

        case FETCH_PACKAGE_PAGE:
            return {
                ...state,
                venue: action.venue,
                packagePageVenue: action.packagePageVenue,
                packages: action.packages,
                menus: action.menus,
                isLoadingVenuePage: action.isLoadingVenuePage,
                similarVenues: action.similarVenues,
                popularVenues: action.popularVenues,
            };

        case FETCH_REVIEWS_FOR_PAGE:
            return {
                ...state,
                isLoadingUserReviewsPage: action.isLoadingUserReviewsPage,
                isFetchingUserReviews: action.isFetchingUserReviews,
                currentUserReviewPage: action.currentUserReviewPage,
            };

        case FETCH_REVIEW_SUCCESS:
            let userReviews = state.userReviews;
            if (action.userReviews && action.userReviews.length > 0) {
                userReviews = userReviews.concat(action.userReviews);
            } else {
                userReviews = [];
            }
            return {
                ...state,
                isLoadingUserReviewsPage: action.isLoadingUserReviewsPage,
                isFetchingUserReviews: action.isFetchingUserReviews,
                userReviews: userReviews,
                userReviewCount: action.userReviewCount,
            };

        case FETCHING_REVIEW:
            return {
                ...state,
                isFetchingUserReviews: action.isFetchingUserReviews,
                comments: action.comments,
                totalCommentsCount: action.totalCommentsCount,
            };

        case FETCH_REVIEW:
            return {
                ...state,
                isFetchingUserReviews: action.isFetchingUserReviews,
                comments: action.comments,
                totalCommentsCount: action.totalCommentsCount,
            };

        case FETCH_USER_COMMENT:
            return {
                ...state,
                userComment: action.userComment,
                userHasCommented: action.userHasCommented,
            };

        case TOGGLE_NEW_COMMENT:
            return {
                ...state,
                isPostingUserComment: action.isPostingUserComment,
            };

        case UPDATE_VENUE_USER_REVIEW:
            userReviews = state.userReviews.map((item) => {
                if (item._id === action.commentId) {
                    return action.comment;
                } else {
                    return item;
                }
            });
            return {
                ...state,
                isSavingUserProfileComment: action.isSavingUserProfileComment,
                userReviews: userReviews,
            };

        case UPDATING_VENUE_USER_REVIEW:
            return {
                ...state,
                isSavingUserProfileComment: action.isSavingUserProfileComment,
            };

        case FETCHING_VENUE_COMMENTS:
            return {
                ...state,
                isFetchingComments: action.isFetchingComments,
            };

        case FETCH_VENUE_COMMENTS:
            let commentObjectMap = {};
            let comments = state?.comments.concat(action.comments);
            if (comments) {
                comments.forEach((item) => {
                    commentObjectMap[item._id] = 1;
                });
            }
            return {
                ...state,
                reviewPageNum: action.reviewPageNum,
                isFetchingComments: action.isFetchingComments,
                comments: comments,
                commentMap: commentObjectMap,
                totalReviewCount: action.totalReviewCount,
            };

        case EDIT_USER_COMMENT:
            return {
                ...state,
                isEditingUserComment: action.isEditingUserComment,
            };

        case FETCHING_REPORTED_COMMENT:
            return {
                ...state,
                isLoadingReviewReport: action.isLoadingReviewReport,
            };

        case FETCH_REPORTED_COMMENT:
            return {
                ...state,
                isLoadingReviewReport: action.isLoadingReviewReport,
                reportedComment: action.reportedComment,
                isReportingComment: action.isReportingComment,
            };

        case UPDATING_REPORTED_COMMENT:
            return {
                ...state,
                isReportingComment: action.isReportingComment,
            };

        case TOGGLE_NEW_EVENT_PLAN_MODAL:
            return {
                ...state,
                isNewEventFormVisible: action.isNewEventFormVisible,
            };

        case EVENT_MADE_STATE:
            return {
                ...state,
                isEventMade: action.isEventMade,
            };

        case SET_SELECTED_VENUE:
            return {
                ...state,
                selectedVenue: action.selectedVenue,
            };

        case FETCHING_SEOLINKS:
            return {
                ...state,
                isFetchingSeoLink: action.isFetchingSeoLink,
            };

        case LOAD_SEOLINK:
            return {
                ...state,
                isFetchingSeoLink: action.isFetchingSeoLink,
                seolink: action.seolink,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                pageSize: action.pageSize,
                venueSearchFilters: action.venueSearchFilters,
                sortFilters: action.sortFilters,
                isBaseFiltersLoaded: action.isBaseFiltersLoaded,
                venueSearchParams: action.venueSearchParams,
            };

        case FETCHING_SEARCHLINKS:
            return {
                ...state,
                isFetchingSearchLink: action.isFetchingSearchLink,
            };

        case SET_SORT_FILTERS:
            return {
                ...state,
                sortFilters: action.sortFilters,
            };

        case LOAD_SEARCHLINK:
            return {
                ...state,
                isFetchingSearchLink: action.isFetchingSearchLink,
                searchlink: action.searchlink,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                pageSize: action.pageSize,
                locationFilters: action.locationFilters,
                occasionFilters: action.occasionFilters,
                venuetypeFilters: action.venuetypeFilters,
                amenityFilters: action.amenityFilters,
                minBudgetFilters: action.minBudgetFilters,
                maxBudgetFilters: action.maxBudgetFilters,
                minGuestFilters: action.minGuestFilters,
                maxGuestFilters: action.maxGuestFilters,
                regionFilters: action.regionFilters,
                packagetypeFilters: action.packagetypeFilters,
                sortFilters: action.sortFilters,
            };

        case FETCHING_SIMILAR_VENUES:
            return {
                ...state,
                isFetchingSimilarVenues: action.isFetchingSimilarVenues,
            };

        case FETCH_SIMILAR_VENUES:
            return {
                ...state,
                similarVenues: action.similarVenues,
                isFetchingSimilarVenues: action.isFetchingSimilarVenues,
            };
        // case FETCHING_POPULAR_VEUNES:
        //   return {
        //     ...state,
        //     isFetchingPopularVenues: action.isFetchingPopularVenues,
        //   };

        case FETCH_POPULAR_VENUES:
            return {
                ...state,
                popularVenues: action.popularVenues,
                isFetchingPopularVenues: action.isFetchingPopularVenues,
            };
        case UPDATING_USER_COMMENT:
            return {
                ...state,
                isUpdatingUserComment: action.isUpdatingUserComment,
            };

        case DELETING_USER_COMMENT:
            return {
                ...state,
                isDeletingUserComment: action.isDeletingUserComment,
            };

        case FETCHING_COMPARE_VENUES:
            return {
                ...state,
                isFetchingCompareVenues: action.isFetchingCompareVenues,
            };

        case FETCH_COMPARE_VENUES:
            return {
                ...state,
                compareVenues: action.compareVenues,
                isFetchingCompareVenues: action.isFetchingCompareVenues,
            };

        case FETCHING_VENUE_DATA_FOR_COMPARE_PAGE:
            return {
                ...state,
                isLoadingVenueData: action.isLoadingVenueData,
            };

        case FETCH_VENUE_DATA_FOR_COMPARE_PAGE:
            let compareVenue = state.compareVenue;
            compareVenue = { ...state.compareVenue, ...action.compareVenue };
            return {
                ...state,
                compareVenue: compareVenue,
            };
        case CLEAR_COMPARE_VENUE_DATA:
            let EmpytyCompareVenue = state.compareVenue;
            EmpytyCompareVenue = {};
            return {
                ...state,
                compareVenue: EmpytyCompareVenue,
            };

        case FETCH_QNA_PAGE:
            return {
                ...state,
                qaPageVenue: action.venue,
                venue: action.venue,
                images: action.images,
                qnaList: action.qnaList,
                venueFaqs: action.venueFaqs,
                similarVenues: action.similarVenues,
                popularVenues: action.popularVenues,
                // customerReviews: action.customerReviews,
                // venueExpert: action.venueExpert,
                qnaCount: action.qnaCount,
                isLoadingVenuePage: action.isLoadingVenuePage,
                venueExpertReview: action.venueExpertReview,
                // qaPageVenue: action.qaPageVenue
            };

        case ADD_ANSWER_MODAL_STATE:
            return {
                ...state,
                addAnswerModalVisibleState: action.addAnswerModalVisibilityState,
                answerModalContextState: action.answerModalContextState,
            };

        case LOAD_SUBLINK_PAGE:
            return {
                ...state,
                sublinkPageData: action.sublinkPage,
            };

        case GET_QNA_SUGGESTION_LIST:
            return {
                ...state,
                qnASuggestionList: action.getQnASuggestionList,
            };
        case IS_USER_QUESTION_POSTED:
            return {
                ...state,
                isUserQuestionPosted: action.isUserQuestionPosted,
            };
        case SET_SUCCESS_MODAL_STATE:
            return {
                ...state,
                isSuccessModalVisible: action.isSuccessModalVisible,
            };
        case QUESTION_ALREADY_EXIST:
            return {
                ...state,
                questionAlreadyExistVisiblity: action.questionAlreadyExistModal,
            };
        case FETCH_USER_QUESTION:
            return {
                ...state,
                userAskedQuestionList: action.getUserAskedQuestionList,
                userAskedQuestionCount: action.getUserAskedQuestionCount,
            };
        case DELETING_USER_QUESTION:
            return {
                ...state,
                isDeletingUserQuestion: action.isDeletingUserQuestion,
            };
        case PROCESSING_DELETE_QUESTION:
            return {
                ...state,
                processingDeleteQuestionRequest: action.payload,
            };
        case FETCH_MORE_QNA:
            return {
                ...state,
                isFetchingMoreQna: action.isFetchingMoreQna,
                moreQnaList: action.moreQnaList,
            };

        case IS_OPEN_GALLERY_FOR_SEARCHPAGE:
            clickedVenueAssets = { ...state.clickedVenueAssets };
            if (action.venue && action.venue._id) {
                if (clickedVenueAssets[action.venue._id]) {
                    clickedVenueAssets[action.venue._id].venue = action.venue;
                } else {
                    clickedVenueAssets[action.venue._id] = {};
                    clickedVenueAssets[action.venue._id].venue = action.venue;
                }
            }
            return {
                ...state,
                isVenueGalleryOpen: action.isVenueGalleryOpen,
                isFetchingVenueAssets: action.isFetchingVenueAssets,
                clickedVenueAssets: clickedVenueAssets,
                clickedVenue: action.venue,
            };

        case CLICKED_VENUE_SEARCH_PAGE:
            return {
                ...state,
                clickedVenueSearchPage: action.payload,
            };

        case FETCH_VENUE_SEARCH_PAGE_ALL_ASSET:
            clickedVenueAssets = { ...state.clickedVenueAssets };
            if (action.venue_id) {
                if (clickedVenueAssets[action.venue_id]) {
                    clickedVenueAssets[action.venue_id].images = action.images;
                    clickedVenueAssets[action.venue_id].assets = action.assets;
                } else {
                    clickedVenueAssets[action.venue_id] = {};
                    clickedVenueAssets[action.venue_id].images = action.images;
                    clickedVenueAssets[action.venue_id].assets = action.assets;
                }
            }
            return {
                ...state,
                isFetchingVenueAssets: false,
                clickedVenueAssets: clickedVenueAssets,
            };
        case UPDATE_QNA_HOMEPAGE:
            return {
                ...state,
                updateQnaPage: action.val,
            };

        case SET_VENUE_TOUR_MODAL_VISIBILTIY:
            return {
                ...state,
                isVenueTourModalVisible: action.isVenueTourModalVisible,
            };
        default:
            return state;
    }
};

export const getVenuePage = (state) => state.venue.venue;

// Export Reducer
export default VenueReducers;
